import React, { useMemo, useState } from "react";
import { AutoComplete, Typography } from "antd";
import { SbInput, PlusOutlined } from "uiCore";

import { OptionInputWrapStyled } from "./LegalEntityManagement.styles";

const { Text } = Typography;

const OptionAddInput = ({
  placeholder,
  onAdd,
  existingValues = [],
  options = [],
}) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);

  const existingLower = useMemo(
    () => new Set(existingValues.map((v) => v?.toLowerCase())),
    [existingValues],
  );

  // Suggestions: filter out options already added under this parent, then
  // narrow further by what the user has typed (case-insensitive substring).
  const dropdownOptions = useMemo(() => {
    const search = value.trim().toLowerCase();
    return options
      .filter((v) => {
        if (!v) return false;
        const lower = v.toLowerCase();
        if (existingLower.has(lower)) return false;
        return !search || lower.includes(search);
      })
      .map((v) => ({ value: v, label: v }));
  }, [options, existingLower, value]);

  const submit = (raw) => {
    const trimmed = (raw ?? value).trim();
    if (!trimmed) return;
    if (existingLower.has(trimmed.toLowerCase())) {
      setError("Already exists");
      return;
    }
    onAdd(trimmed);
    setValue("");
    setError("");
    setOpen(false);
  };

  return (
    <OptionInputWrapStyled>
      <AutoComplete
        style={{ width: "100%" }}
        value={value}
        open={open}
        onOpenChange={setOpen}
        options={dropdownOptions}
        onChange={(v) => {
          setValue(v);
          if (error) setError("");
        }}
        onSelect={(v) => submit(v)}
      >
        <SbInput
          placeholder={placeholder}
          status={error ? "error" : undefined}
          onKeyDown={(e) => {
            if (e.key === "Enter") submit();
          }}
          suffix={<PlusOutlined onClick={() => submit()} />}
        />
      </AutoComplete>
      {error && <Text type="danger">{error}</Text>}
    </OptionInputWrapStyled>
  );
};

export default OptionAddInput;
